module.exports = "<div class=\"resource-item-content product-reel-item\">\r\n    <h3>{{Model.Title}}</h3>\r\n    <p><em>{{Model.Coverage}}</em></p>\r\n    <p>{{Model.Description}}</p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/my-justis/views/partials/product-reel-item.html
// module id = 389
// module chunks = 1